export const aboutAppDefinitionId = '14dbef06-cc42-5583-32a7-3abd44da4908';
export const aboutPageId = '14dbefb9-3b7b-c4e9-53e8-766defd30587';

export const memberAccountBMPath = '/members-account';

export const FOLLOWERS_APP_DEF_ID = '14ebe801-d78a-daa9-c9e5-0286a891e46f';
export const FOLLOWERS_APP_WIDGET_ID = '14ebe825-b273-0d5f-0fd1-e6293322b83b';
